export default __webpack_public_path__ + "static/media/schools_bg.b0abd56c.jpg";